import React from "react";
import {Blocker} from 'react-router-dom';
import {PillButton} from "./PillButton";
import {Modal} from "./Modal";
import {LeaveWithoutSavingWarningUtility} from "./LeaveWithoutSavingWarningUtility";

interface LWSModalProps {
    navigationBlocker: Blocker;
}

export let LeaveWithoutSavingWarningModal = function (props: LWSModalProps) {
    let navigationBlocker = props.navigationBlocker;
    return (
        <div>
            {(() => {
                if (navigationBlocker.state === "blocked") {
                    return (
                        <Modal
                            boxClass="leave-without-saving-warning-modal"
                            headerText="Leave Without Saving?"
                            onClickCloseOption={() => navigationBlocker.reset()}
                        >
                            <div className="leave-without-saving-warning-modal-body">
                                You have unsaved changes. Are you sure you want to leave without saving?
                            </div>

                            <div className="leave-without-saving-warning-modal-options">
                                <div className="leave-without-saving-warning-modal-option">
                                    <PillButton
                                        onClick={() => {
                                            LeaveWithoutSavingWarningUtility.disableLeaveWithoutSavingWarnings()
                                            navigationBlocker.proceed()
                                        }}
                                        buttonClasses="leave-without-saving-warning-modal-button leave-without-saving-warning-modal-leave-button"
                                        buttonText="LEAVE WITHOUT SAVING"
                                        buttonTextClasses="leave-without-saving-warning-modal-button-text"
                                    />
                                </div>
                                <div className="leave-without-saving-warning-modal-option">
                                    <PillButton
                                        onClick={() => navigationBlocker.reset()}
                                        buttonClasses="leave-without-saving-warning-modal-button leave-without-saving-warning-modal-cancel-button"
                                        buttonText="CANCEL"
                                        buttonTextClasses="leave-without-saving-warning-modal-button-text"
                                    />
                                </div>
                            </div>
                        </Modal>
                    )
                } else {
                    return null;
                }
            })()}
        </div>
    );
};
